import { i18n } from "@lingui/core"
import { Locale as CommonLocale } from '@ssc-booking/api-contracts';
import * as Currency from '@ssc-booking/api-contracts/src/currency';
import * as Amount from "@ssc-booking/api-contracts/src/amount"

export type Locale = CommonLocale
export const Locale = CommonLocale

export const formatCurrency = (value: number, currency: Currency.Currency): string =>
    i18n.number(value, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })

export const formatAmount = (amount: Amount.Amount, noNegative = false): string =>
    formatCurrency(noNegative ? Math.abs(amount.value) : amount.value, amount.currency)
